import UrlParse from 'url-parse';
import { handleWindow } from '@/utils';

const win = handleWindow();

export const isOwnerLink = (url, forDev) => {
  if (forDev) {
    return true;
  }

  if (url) {
    const u = new UrlParse(url);
    if (u.protocol !== 'https:' && u.protocol !== 'http:') {
      return false;
    }
    return !u.host || u.host === window.location.host
      || u.host === 'entertainment.dji.com';
  }
  return false;
};

export const getUrlQueries = (url = win.location.href) => (new UrlParse(url, true).query);

export const getUrlQuery = (key, url = win.location.href) => getUrlQueries(url)[key];

export const shouldUseState = (u) => {
  if (!u) {
    return false;
  }
  return isOwnerLink(u.href);
};

export default {
  getUrlQueries,
  getUrlQuery,
};
